import PropTypes from 'prop-types';
import compose from '../../hoc/compose';
import template from './palettePickerDialog.jsx';
import displayNames from '../displayNames';
var PalettePickerDialog = function PalettePickerDialog(props) {
  return template(props);
};
PalettePickerDialog.displayName = displayNames.PALETTE_PICKER_DIALOG;
PalettePickerDialog.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Custom text content. `colorPalettes` - the heading above the list of palettes */
  textKeys: PropTypes.shape({
    colorPalettes: PropTypes.string
  }),
  /** Current selected palette */
  value: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string)),
  /** A list of palettes */
  palettePresets: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.string))),
  /** Invoked on selecting a palette. Parameters:
   *  <ol>
   *    <li><code>palette</code> - the selected palette <code>{string[][]}</code></li>
   *    <li><code>paletteIndex</code> - the index of the selected palette on <code>palettePresets</code> list <code>{number}</code></li>
   *  </ol>
   */
  onChange: PropTypes.func
};
PalettePickerDialog.defaultProps = {
  textKeys: {
    colorPalettes: 'Color Palettes'
  }
};
export default compose(PalettePickerDialog);